module.exports = __webpack_public_path__ + "portfolio.svg?582e89bbab276c4569e8d2346ec29aff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio.svg
// module id = 306
// module chunks = 2